"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTimeChain = exports.timeFns = void 0;
const ES = __importStar(require("../ecmascript"));
const durationFns_1 = require("./durationFns");
const dateTimeFns_1 = require("./dateTimeFns");
const zonedDateTimeFns_1 = require("./zonedDateTimeFns");
const format_1 = __importDefault(require("../format"));
const ObjectAssign = Object.assign;
const DISALLOWED_UNITS = ['year', 'month', 'week', 'day'];
const MAX_INCREMENTS = {
    hour: 24,
    minute: 60,
    second: 60,
    millisecond: 1000
};
exports.timeFns = {
    now(timeZone = ES.SystemTimeZone()) {
        timeZone = ES.ToTemporalTimeZone(timeZone);
        return ES.TemporalDateTimeToTime(ES.BuiltinTimeZoneGetPlainDateTimeFor(timeZone, ES.SystemUTCEpochMilliSeconds()));
    },
    fromNumbers(hour = 0, minute = 0, second = 0, millisecond = 0) {
        hour = ES.ToIntegerThrowOnInfinity(hour);
        minute = ES.ToIntegerThrowOnInfinity(minute);
        second = ES.ToIntegerThrowOnInfinity(second);
        millisecond = ES.ToIntegerThrowOnInfinity(millisecond);
        ES.RejectTime(hour, minute, second, millisecond);
        return ES.CreateTemporalTime(hour, minute, second, millisecond);
    },
    isValid(time) {
        return ES.IsTemporalTime(time);
    },
    assertIsValid(time) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
    },
    getHour(time) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        return ES.GetTimeSlots(time).hour;
    },
    getMinute(time) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        return ES.GetTimeSlots(time).minute;
    },
    getSecond(time) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        return ES.GetTimeSlots(time).second;
    },
    getMillisecond(time) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        return ES.GetTimeSlots(time).millisecond;
    },
    with(time, temporalTimeLike, options = undefined) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        if (typeof temporalTimeLike !== 'object') {
            throw new TypeError('invalid argument');
        }
        if (temporalTimeLike.timeZone !== undefined) {
            throw new TypeError('with() does not support a timeZone property');
        }
        options = ES.GetOptionsObject(options);
        const overflow = ES.ToTemporalOverflow(options);
        const props = ES.ToPartialRecord(temporalTimeLike, [
            'hour',
            'microsecond',
            'millisecond',
            'minute',
            'nanosecond',
            'second'
        ]);
        if (!props) {
            throw new TypeError('invalid time-like');
        }
        const fields = ES.ToTemporalTimeRecord(ES.GetTimeSlots(time));
        let { hour, minute, second, millisecond } = ObjectAssign(fields, props);
        ({ hour, minute, second, millisecond } = ES.RegulateTime(hour, minute, second, millisecond, overflow));
        return ES.CreateTemporalTime(hour, minute, second, millisecond);
    },
    add(time, temporalDurationLike) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        const duration = ES.ToLimitedTemporalDuration(temporalDurationLike);
        const { hours, minutes, seconds, milliseconds } = duration;
        let { hour, minute, second, millisecond } = ES.GetTimeSlots(time);
        ({ hour, minute, second, millisecond } = ES.AddTime(hour, minute, second, millisecond, hours, minutes, seconds, milliseconds));
        ({ hour, minute, second, millisecond } = ES.RegulateTime(hour, minute, second, millisecond, 'reject'));
        return ES.CreateTemporalTime(hour, minute, second, millisecond);
    },
    subtract(time, temporalDurationLike) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        let duration = ES.ToLimitedTemporalDuration(temporalDurationLike);
        const { hours, minutes, seconds, milliseconds } = duration;
        let { hour, minute, second, millisecond } = ES.GetTimeSlots(time);
        ({ hour, minute, second, millisecond } = ES.AddTime(hour, minute, second, millisecond, -hours, -minutes, -seconds, -milliseconds));
        ({ hour, minute, second, millisecond } = ES.RegulateTime(hour, minute, second, millisecond, 'reject'));
        return ES.CreateTemporalTime(hour, minute, second, millisecond);
    },
    until(time, other, options = undefined) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalTime(other);
        options = ES.GetOptionsObject(options);
        const largestUnit = ES.ToLargestTemporalUnit(options, 'auto', DISALLOWED_UNITS, 'hour');
        const smallestUnit = ES.ToSmallestTemporalUnit(options, 'millisecond', DISALLOWED_UNITS);
        ES.ValidateTemporalUnitRange(largestUnit, smallestUnit);
        const roundingMode = ES.ToTemporalRoundingMode(options, 'trunc');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, MAX_INCREMENTS[smallestUnit], false);
        const timeSlots = ES.GetTimeSlots(time);
        const otherSlots = ES.GetTimeSlots(other);
        let { hours, minutes, seconds, milliseconds } = ES.DifferenceTime(timeSlots.hour, timeSlots.minute, timeSlots.second, timeSlots.millisecond, otherSlots.hour, otherSlots.minute, otherSlots.second, otherSlots.millisecond);
        ({ hours, minutes, seconds, milliseconds } = ES.RoundDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds, roundingIncrement, smallestUnit, roundingMode));
        ({ hours, minutes, seconds, milliseconds } = ES.BalanceDuration(0, hours, minutes, seconds, milliseconds, largestUnit));
        return ES.CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
    },
    since(time, other, options = undefined) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalTime(other);
        options = ES.GetOptionsObject(options);
        const largestUnit = ES.ToLargestTemporalUnit(options, 'auto', DISALLOWED_UNITS, 'hour');
        const smallestUnit = ES.ToSmallestTemporalUnit(options, 'millisecond', DISALLOWED_UNITS);
        ES.ValidateTemporalUnitRange(largestUnit, smallestUnit);
        const roundingMode = ES.ToTemporalRoundingMode(options, 'trunc');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, MAX_INCREMENTS[smallestUnit], false);
        const timeSlots = ES.GetTimeSlots(time);
        const otherSlots = ES.GetTimeSlots(other);
        let { hours, minutes, seconds, milliseconds } = ES.DifferenceTime(timeSlots.hour, timeSlots.minute, timeSlots.second, timeSlots.millisecond, otherSlots.hour, otherSlots.minute, otherSlots.second, otherSlots.millisecond);
        ({ hours, minutes, seconds, milliseconds } = ES.RoundDuration(0, 0, 0, 0, -hours, -minutes, -seconds, -milliseconds, roundingIncrement, smallestUnit, ES.NegateTemporalRoundingMode(roundingMode)));
        hours = -hours;
        minutes = -minutes;
        seconds = -seconds;
        milliseconds = -milliseconds;
        ({ hours, minutes, seconds, milliseconds } = ES.BalanceDuration(0, hours, minutes, seconds, milliseconds, largestUnit));
        return ES.CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
    },
    round(time, options) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        if (options === undefined)
            throw new TypeError('options parameter is required');
        options = ES.GetOptionsObject(options);
        const smallestUnit = ES.ToSmallestTemporalUnit(options, undefined, DISALLOWED_UNITS);
        if (smallestUnit === undefined)
            throw new RangeError('smallestUnit is required');
        const roundingMode = ES.ToTemporalRoundingMode(options, 'halfExpand');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, MAX_INCREMENTS[smallestUnit], false);
        let { hour, minute, second, millisecond } = ES.GetTimeSlots(time);
        ({ hour, minute, second, millisecond } = ES.RoundTime(hour, minute, second, millisecond, roundingIncrement, smallestUnit, roundingMode));
        return ES.CreateTemporalTime(hour, minute, second, millisecond);
    },
    equals(time, other) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        if (!ES.IsTemporalTime(other))
            throw new TypeError('invalid receiver');
        const slots1 = ES.GetTimeSlots(time);
        const slots2 = ES.GetTimeSlots(other);
        for (const slot of ['hour', 'minute', 'second', 'millisecond']) {
            const val1 = slots1[slot];
            const val2 = slots2[slot];
            if (val1 !== val2)
                return false;
        }
        return true;
    },
    toDateTime(time, temporalDate) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        temporalDate = ES.ToTemporalDate(temporalDate);
        let { year, month, day } = ES.GetDateSlots(temporalDate);
        let { hour, minute, second, millisecond } = ES.GetTimeSlots(time);
        return ES.CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
    },
    toZonedDateTime(time, item) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        if (typeof item !== 'object') {
            throw new TypeError('invalid argument');
        }
        const dateLike = item.date;
        if (dateLike === undefined) {
            throw new TypeError('missing date property');
        }
        const temporalDate = ES.ToTemporalDate(dateLike);
        const timeZoneLike = item.timeZone;
        if (timeZoneLike === undefined) {
            throw new TypeError('missing timeZone property');
        }
        const timeZone = ES.ToTemporalTimeZone(timeZoneLike);
        const { year, month, day } = ES.GetDateSlots(temporalDate);
        const { hour, minute, second, millisecond } = ES.GetTimeSlots(time);
        const dt = ES.CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
        const instant = ES.BuiltinTimeZoneGetInstantFor(timeZone, dt, 'compatible');
        return ES.CreateTemporalZonedDateTime(instant, timeZone);
    },
    getFields(time) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        return ES.GetTimeSlots(time);
    },
    from(item, options = undefined) {
        options = ES.GetOptionsObject(options);
        const overflow = ES.ToTemporalOverflow(options);
        if (ES.IsTemporalTime(item)) {
            const slots = ES.GetTimeSlots(item);
            return ES.CreateTemporalTime(slots.hour, slots.minute, slots.second, slots.millisecond);
        }
        return ES.ToTemporalTime(item, overflow);
    },
    compare(one, two) {
        one = ES.ToTemporalTime(one);
        two = ES.ToTemporalTime(two);
        const slots1 = ES.GetTimeSlots(one);
        const slots2 = ES.GetTimeSlots(two);
        for (const slot of ['hour', 'minute', 'second', 'millisecond']) {
            const val1 = slots1[slot];
            const val2 = slots2[slot];
            if (val1 !== val2)
                return ES.ComparisonResult(val1 - val2);
        }
        return 0;
    },
    format(time, formatString) {
        if (!ES.IsTemporalTime(time))
            throw new TypeError('invalid receiver');
        return format_1.default(ES.GetTimeSlots(time), formatString);
    },
    chain: buildTimeChain
};
function buildTimeChain(time) {
    return {
        value() {
            return time;
        },
        getHour() {
            return ES.buildChain(exports.timeFns.getHour(time));
        },
        getMinute() {
            return ES.buildChain(exports.timeFns.getMinute(time));
        },
        getSecond() {
            return ES.buildChain(exports.timeFns.getSecond(time));
        },
        getMillisecond() {
            return ES.buildChain(exports.timeFns.getMillisecond(time));
        },
        with(timeLike, options) {
            return buildTimeChain(exports.timeFns.with(time, timeLike, options));
        },
        add(temporalDurationLike, options) {
            return buildTimeChain(exports.timeFns.add(time, temporalDurationLike, options));
        },
        subtract(temporalDurationLike, options) {
            return buildTimeChain(exports.timeFns.subtract(time, temporalDurationLike, options));
        },
        until(other, options) {
            return durationFns_1.buildDurationChain(exports.timeFns.until(time, other, options));
        },
        since(other, options) {
            return durationFns_1.buildDurationChain(exports.timeFns.since(time, other, options));
        },
        round(options) {
            return buildTimeChain(exports.timeFns.round(time, options));
        },
        equals(other) {
            return ES.buildChain(exports.timeFns.equals(time, other));
        },
        toDateTime(date) {
            return dateTimeFns_1.buildDateTimeChain(exports.timeFns.toDateTime(time, date));
        },
        toZonedDateTime(item) {
            return zonedDateTimeFns_1.buildZonedDateTimeChain(exports.timeFns.toZonedDateTime(time, item));
        },
        getFields() {
            return ES.buildChain(exports.timeFns.getFields(time));
        },
        format(formatString) {
            return ES.buildChain(exports.timeFns.format(time, formatString));
        }
    };
}
exports.buildTimeChain = buildTimeChain;
